import axios from 'axios'
import qs from 'qs'
import { apiUrl } from 'Services/accessUrl'
import jsonWebToken from 'Services/jsonWebToken'
import { filterShallowObject } from 'Services/extraObject'
import { ApiResult, ApiQuoteRequestDetail } from 'Types'

const endpoint = `${apiUrl.stable}/solicitacoes`

/**
 * Returns a list of requests sent by the signed user
 * @param {number} [page=1] Desired page of results
 * @param {object} [query={}] Filters and stuff you know
 * @param {string} [query.filter] Term that will filter the requests
 * @param {number} [query.authorId] Author that made the request
 * @param {Date} [query.dateStart] Show request beyond a specific period
 * @param {Date} [query.dateEnd] Show request until a specific period
 * @returns {Promise.<{ data: ApiQuoteRequestList }>}
 */
export const getRequestList = (page = 1, query = {}) => {
  const url = `${endpoint}`

  const options = {
    Page: page,
    Filter: query.filter || null,
    AuthorIds: query.authors || null,
    Status: query.status || null,
    SortType: query.order || null,
    Characteristic: query.characteristic || null,
    StartDate: query.startDate || null,
    EndDate: query.endDate || null,
    AddressId: query.addressId || null
  }

  const params = filterShallowObject(options, item => item !== null)

  const axiosConfig = {
    params,
    headers: { ...jsonWebToken.header, },
    paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'})
  }

  return axios.get(url, axiosConfig)
}

/**
 * Returns a list of requests sent by the signed user
 * @param {number} [page=1] Desired page of results
 * @param {object} [query={}] Filters and stuff you know
 * @param {string} [query.filter] Term that will filter the requests
 * @param {number} [query.authorId] Author that made the request
 * @param {Date} [query.dateStart] Show request beyond a specific period
 * @param {Date} [query.dateEnd] Show request until a specific period
 * @returns {Promise.<{ data: ApiQuoteRequestList }>}
 */
export const getLastBudgetList = (page = 1, query = {}) => {
  const url = `${endpoint}/ultimos-orcamentos`

  const options = {
    Page: page,
    Filter: query.filter || null,
    AuthorIds: query.authors || null,
    Status: query.status || null,
    SortType: query.order || null,
    Characteristic: query.characteristic || null,
    StartDate: query.startDate || null,
    EndDate: query.endDate || null,
    AddressId: query.addressId || null
  }

  const params = filterShallowObject(options, item => item !== null)

  const axiosConfig = {
    params,
    headers: { ...jsonWebToken.header, },
    paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'})
  }

  return axios.get(url, axiosConfig)
}

/**
 * Returns a list of requests sent by the signed user
 * @param {number} [page=1] Desired page of results
 * @param {object} [query={}] Filters and stuff you know
 * @param {string} [query.filter] Term that will filter the requests
 * @param {number} [query.authorId] Author that made the request
 * @param {Date} [query.dateStart] Show request beyond a specific period
 * @param {Date} [query.dateEnd] Show request until a specific period
 * @returns {Promise.<{ data: ApiQuoteRequestList }>}
 */
export const getLastMessageList = (page = 1, query = {}) => {
  const url = `${endpoint}/ultimas-mensagens`

  const options = {
    Page: page,
    Filter: query.filter || null,
    AuthorIds: query.authors || null,
    Status: query.status || null,
    SortType: query.order || null,
    Characteristic: query.characteristic || null,
    StartDate: query.startDate || null,
    EndDate: query.endDate || null,
    AddressId: query.addressId || null
  }

  const params = filterShallowObject(options, item => item !== null)

  const axiosConfig = {
    params,
    headers: { ...jsonWebToken.header, },
    paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'})
  }

  return axios.get(url, axiosConfig)
}

/**
 * Returns a list of suppliers that requires evaluation
 * @param {number} [page=1] Desired page of results
 * @param {object} [query={}] Filters and stuff you know
 * @param {string} [query.filter] Term that will filter the requests
 * @param {number} [query.authorId] Author that made the request
 * @param {Date} [query.dateStart] Show request beyond a specific period
 * @param {Date} [query.dateEnd] Show request until a specific period
 * @returns {Promise.<{ data: ApiQuoteRequestList }>}
 */
export const getSupplierEvaluationList = (page = 1, query = {}) => {
  const url = `${endpoint}/avaliacoes-disponiveis`

  const options = {
    Page: page,
    Filter: query.filter || null,
    AuthorIds: query.authors || null,
    Status: query.status || null,
    SortType: query.order || null,
    Characteristic: query.characteristic || null,
    StartDate: query.startDate || null,
    EndDate: query.endDate || null,
    AddressId: query.addressId || null
    // TODO: add status filter?
  }

  const params = filterShallowObject(options, item => item !== null)

  const axiosConfig = {
    params,
    headers: { ...jsonWebToken.header, },
    paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'})
  }

  return axios.get(url, axiosConfig)
}

export const getLastestActivitiesList = (page = 1, query = {}) => {
  const url = `${endpoint}/atividades-recentes`

  const options = {
    Page: page,
    Filter: query.filter || null,
    Status: query.status || null,
    SortType: query.order || null,
    StartDate: query.startDate || null,
    EndDate: query.endDate || null,
    AddressId: query.addressId || null
  }

  const params = filterShallowObject(options, item => item !== null)

  const axiosConfig = {
    params,
    headers: { ...jsonWebToken.header, },
    paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'})
  }

  return axios.get(url, axiosConfig)
}


export const getQuoteStatus = (page = 1, query = {}, requestPath) => {
  const url = `${endpoint}/status${requestPath}`

  const options = {
    Page: page,
    Filter: query.filter || null,
    AuthorIds: query.authors || null,
    Status: query.status || null,
    Characteristic: query.characteristic || null,
    StartDate: query.startDate || null,
    EndDate: query.endDate || null,
    AddressId: query.addressId || null
  }

  const params = filterShallowObject(options, item => item !== null)

  const axiosConfig = {
    params,
    headers: { ...jsonWebToken.header, },
    paramsSerializer: params => qs.stringify(params, {arrayFormat: 'repeat'})
  }

  return axios.get(url, axiosConfig)
}

/** Returns information about a specific request */
export const getRequest = (quotationId: any): ApiResult<ApiQuoteRequestDetail> => {
  const url = `${endpoint}/detalhes`

  const axiosConfig = {
    params: {
      identifierOrId: quotationId,
    },
    headers: {
      ...jsonWebToken.header,
    }
  }

  return axios.get(url, axiosConfig)
}

/**
 * Returns all the available states of specific request
 * @param {number} quotationId
 * @returns {Promise.<{ data: ApiQuoteRequestStatus }>}
 */
export const getRequestStatus = (quotationId) => {
  const url = `${endpoint}/flags`

  const params = {
    quotationId: quotationId,
  }

  const headers = {
    ...jsonWebToken.header,
  }


  return axios.get(url, { params, headers })
}

/**
 * Returns all the available states of specific request
 * @returns {Promise.<{ data: ApiQuoteMostRatedCategories }>}
 */
export const getQuoteMostRatedCategories = () => {
  const url = `${endpoint}/especialidades/mais-cotadas`

  const headers = {
    ...jsonWebToken.header,
  }


  return axios.get(url, { headers })
}

/**
 * Returns the history of actions and messages of a specific request
 * @param {number} quotationId The id of the desired quotation
 * @param {number} companyId The id of the desired company
 * @param {number} connectionId The SignalR connection id for realtime chat
 * @param {number} [page=1] Desired page of results
 * @returns {Promise.<{ data: ApiChatHistory }>}
 */
export const getRequestHistory = (quotationId, companyId, connectionId, page = 1) => {
  const url = `${endpoint}/historico`

  const params = {
    QuotationId: quotationId,
    CompanyId: companyId,
    ConnectionId: connectionId,
    Page: page,
  }

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { params, headers })
}

/**
 * Returns the history previous messages based on a specific datetime
 * @param {string} dateISO A date string in ISO format (ISO 8601)
 * @param {number} [pageSize=10] How many messages should be retrieved
 * @returns {Promise.<{ data: ApiChatHistoryMessage[] }>}
 */
export const getHistoryPreviousMessages = (negotiationId, pageNumber, pageSize = 10) => {
  const url = `${endpoint}/historico/mensagens-anteriores`

  const params = {
    CompanyQuotationId: negotiationId,
    Page: pageNumber,
    PageSize: pageSize
  }

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { params, headers })
}

/**
 * @param {number} quotationId
 * @returns {Promise.<{ data: ApiChatHistoryStatus[] }>}
 */
export const getHistoryStatus = (quotationId) => {
  const url = `${endpoint}/historico/indices`

  const params = {
    quotationId: quotationId,
  }

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { params, headers })
}

/**
 * Add an action to the the history of a specific request
 * @param {ApiChatNewMessage} data
 * @returns {Promise.<{ data: ApiChatNewMessage }>}
 */
export const updateRequestHistory = (data) => {
  const url = `${endpoint}/historico`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })
}

/**
 * Update the status of a specific request. This will not change the status for the other part.
 * @param {number} quotationId The id of the desired quotation
 * @param {number} status The id of the desired status
 */
export const updateRequestStatus = (quotationId, status) => {
  const url = `${endpoint}/alterar/status`

  const headers = { ...jsonWebToken.header, }

  const data = {
    quotationId: quotationId,
    status: status
  }

  return axios.put(url, data, { headers })
}

/**
 * @param {number} quotationId
 * @returns {Promise.<{ data: ApiQuoteRequestReview[] }>}
 */
export const getRequestReview = (quotationId) => {
  const url = `${endpoint}/avaliacao`

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    idQuotation: quotationId,
  }

  return axios.get(url, { params, headers })
}

/**
 * @param {ApiQuoteRequestReviewAdd} data
 */
export const addCompanyReview = (data) => {
  const url = `${endpoint}/avaliacao/salvar`

  const headers = { ...jsonWebToken.header }

  return axios.post(url, data, { headers })
}

/**
 * @param {ApiQuoteRequestReviewUpdate} data
 */
export const updateCompanyReview = (data) => {
  const url = `${endpoint}/avaliacao/atualizar`

  const headers = { ...jsonWebToken.header }

  return axios.put(url, data, { headers })
}

export const getAuthorsList = () => {
  const url = `${endpoint}/autores`

  const axiosConfig = {
    headers: { ...jsonWebToken.header }
  }

  return axios.get(url, axiosConfig)
}

export const getAddressList = () => {
  const url = `${endpoint}/enderecos`

  const axiosConfig = {
    headers: { ...jsonWebToken.header }
  }

  return axios.get(url, axiosConfig)
}

export default {
  getRequest,
  getRequestHistory,
  getRequestList,
  getLastBudgetList,
  updateRequestHistory,
  updateRequestStatus,
  getLastestActivitiesList,
}